import styled from 'styled-components'
import Button from '../../components/Button'

export const Background = styled.div`
    background-image: url('/assets/img/bg.png');
    background-position: center top;
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    position: absolute;
    min-width: 1024px;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    @media only screen and (max-width: 728px) {
        top: 0;
        left: 0;
        min-width: 100%;
        min-height: 100%;
    }
`

export const ContentPanel = styled.div`
    width: 600px;
    height: 500px;
    padding: 60px 75px 48px;
    border-radius: 12px;
    background-color: #fdfdfd;
    background-color: ${({ theme }) => theme.colors.white};
    display: flex;
    flex-direction: column;
    @media only screen and (max-width: 728px) {
        width: 200px;
        padding: 20px 35px 18px;
    }
`

export const Title = styled.h3`
    font-weight: bold;
    color: ${({ theme }) => theme.colors.grey['100']};
    font-size: 20px;
`

export const Subtitle = styled.h4`
    align-self: center;
    text-align: center;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.green['100']};
    font-size: 28px;
`

export const Logo = styled.img`
    align-self: center;
    height: 42px;
`
export const List = styled.li`
    margin-left: 20px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: ${({ theme }) => theme.colors.grey['100']};
    @media only screen and (max-width: 728px) {
        font-size: 12px;
    }
`
export const Text = styled.p`
    height: 28px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.75;
    letter-spacing: normal;
    color: ${({ theme }) => theme.colors.grey['100']};
    @media only screen and (max-width: 728px) {
        font-size: 14px;
    }
`
export const textLogo = styled.p`
    height: 28px;
    margin: 24px 8px 40px 10px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.75;
    letter-spacing: normal;
    text-align: center;
    color: ${({ theme }) => theme.colors.grey['100']};
`
export const ErrorOverlay = styled.div`
    display: flex;
    margin: 0px 20px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    max-width: 600px;
    width: 600px;
    border-radius: 12px 12px 0px 0px;
    background-color: ${({ theme }) => theme.colors.grey['100']}99;
    padding: 18px;
    text-align: center;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.white};
`
export const Login = styled(Button)`
    background-color: ${({ theme }) => theme.colors.white};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    max-height: 48px;
    border: 2px solid ${({ theme }) => theme.colors.grey['100']};
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey['100']};
    padding: 14px 24px;
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
    box-shadow: 0 1px 4px 0 rgba(112, 112, 112, 0.4);
    text-transform: uppercase;
    text-align: center;
    font-weight: 500;
    line-height: 16px;
    cursor: pointer;
`
